export const texts = Object.freeze({
  title: 'Ready to apply?',
  linkText: 'Apply here for ',
});

export const ENTITY_NAME = 'shopping_apply_now_link';

export const SECTION_NAME = 'cc_article_footer';
